import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";

// Authentication
import LockScreen from "pages/AuthenticationInner/LockScreen";
import Credentials from "pages/Credentials/index";
import CreditCardProcessing from '../pages/creditCardProcessing'
import MerchantPage from "pages/Merchant";
import LoganAdmin from "pages/LoganAdmin";
import LoganAI from "pages/LoganAI";
// Pages

// pages

import TermsContions from "pages/Pages/Terms&Condition/TermsContions";
import TimeLine from "pages/Pages/TimeLine/TimeLine";
import Faqs from "pages/Pages/FAQs/Faqs";
import Contacts from "pages/Pages/Contact/Contacts";
import Contractors from "pages/Pages/Contact/contractors";
import Pricing from "pages/Pages/Pricing/index";
import Profile from "pages/Pages/Profile/index";
import ModernProfile from "pages/ModernProfile";
import ContracotrProfile from "pages/Pages/ContractorProfile/index";
import { RecentContractorProfile } from "pages/recentContractors/profile";
import VersionControl from 'pages/versionControle/index'
import ProfileSetting from "pages/Pages/Profilesetting/index";
import Projects from "pages/Projects";
//import ProjectOverview from "pages/Projects/ProjectOverview/PropertyOverview";
import ProjectOverview from "pages/Projects/LeadsOverview/Overview";
import RequestedLeads from "pages/Requested Leads";
import OngoingLeads from "pages/OngoingLeads";
//import ProposalOverview from "pages/Projects/ProposalDetails/ProposalOverview";
// Tables

//Invoice
import OverviewInvoice from "pages/Invoices/OverviewInvoice/OverviewInvoice";
import CreateInvoice from "pages/Invoices/CreateInvoice/CreateInvoice";

//Contracts
import OverviewContracts from "pages/Contracts/OverviewInvoice/OverviewInvoice";
import CreateContracts from "pages/Contracts/CreateInvoice/CreateInvoice";

//Support Tickets
import TicketsOverview from "pages/SupportTickets/Overview/Index";

//Real Estate
import PropertyOverview from "pages/RealEstate/PropertyOverview/PropertyOverview";
import AddEarning from "pages/RealEstate/AddProperty/AddEarning";

// import Login from "pages/Authentication/Login";

// import Login from "pages/Authentication/Login";

import RealEstate from "pages/Dashboard/RealEstate";
import ListingGrid from "pages/RealEstate/PropertyListingGrid/listingGrid";
import AgentGrid from "pages/RealEstate/PropertyOwners/AgentGrid";
import ContractTutorial from "pages/Tutorial";
import MarketingComponent from "pages/Marketing";
import SubcontractorsGrid from "pages/Subcontractors/SubcontractorGrid";
import OverviewUser from "pages/Projects/user-overview/OverviewUser";
import ListViewInvoice from "pages/Invoices/ListView";
import ListViewContracts from "pages/Contracts/ListView/ListViewInvoice";
import ListViewTickets from "pages/SupportTickets/ListView/ListViewTickets";
import TransactionData from "pages/Transactions/index";

// Authentication
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/Logout";
import GetProject from "pages/Contracts/CreateProject/index";
import CreateContract from "pages/Contracts/CreateProject/CreateContractRouter";
import GuestSubcontractSign from "pages/Contracts/GuestSubcontractSign";
import GuestHomeownerContractSign from "pages/Contracts/GuestHomeownerContractSign";
import CreateSwornContractor from "pages/Contracts/SwornContract/contractor";
import CreateSwornHomeowner from "pages/Contracts/SwornContract/homeowner";

//admin
import AdminContractorProfile from "pages/Admin/contractors/Profilesetting";
import AdminHomeownerProfile from "pages/Admin/Homeowners/Profilesetting";
import AdminContratorsData from "pages/Admin/contractors";
import AdminHomeownersData from "pages/Admin/Homeowners";
import AdminRealEstateAgentsData from "pages/Admin/Real-estate-agents/RealEstateAgentsAdmin";

import AdminFormsData from "pages/Admin/Form Leads";
import AdminSubscribersData from "pages/Admin/subscribers";
import LiveContracts from "pages/Contracts/LiveContracts/LiveContracts";
import LiveContractDetails from "pages/Contracts/LiveContracts/contractDetails";
import Messages from "pages/Messages/messages";
import Chatroom from "pages/Messages/chatRoom";
import Chat from "pages/Chat";
import AIContractChatScreen from 'pages/Contracts/CreateByAI/index'
import ViewSubcontracts from "pages/Contracts/CreateProject/ViewSubcontracts";
import { LoginScreen2 } from "pages/Authentication/LoginScreen";
import NewHomeOwnerDashboard from "pages/Dashboard/RealEstate/newHomeownerDashboard";
import { KYCPendingView } from "pages/kyc/kycStatuspag";
import { KYCForm } from "pages/kyc/kycFormPage";
import NewContractorDetails from "pages/Admin/contractors/newContractorpage";
import NewLeadsPage from "pages/Projects/newLeadsPages";
import LeadsHistory from "pages/Projects/leadsHistory";
import AddPropertyManager from "pages/AddProperty";
import CoupanDashboard from "pages/Coupan";
import AllLeads from "pages/AllLeads";
import CategoryMasterModern from "pages/Admin/masters/catogeryMaster";
import SubCategoryMasterModern from "pages/Admin/masters/subCatogery";
import PropertyInsurance from "pages/insuarance";
import { ComingSoon } from "pages/comingSoon";
import NotificationSender from "pages/PushNotifictaions";
import { LeadDetailsPage } from "pages/LeadDetailsPageHomeowner";
import { RecentContractors } from "pages/recentContractors/page";
import HomeownerListAdmin from "pages/Admin/Homeowners/allHomeownerList";
import HomeownerPage from "pages/RealEstate/Homeowners/addHomeowner";
import ContractExplorePage from "pages/RealEstate/ExploreContractors/Explore";
import { SuggestedContractrDashboard } from "pages/suggestedContractrs/Dashboard";
import InviteHomeOwners from "pages/RealEstate/InviteHoemowner/dashboard";
import EscrowRequest from "pages/escrowRequests";
import TeamManagement from "pages/TeamManagement/team";
import PlatformAccess from "pages/PlatformAccess";
import MlsCacheControl from "pages/Admin/MlsCacheControl";
import PropertyLeadsAdmin from "pages/Admin/PropertyLeads";
import CardsExpiringSoon from "pages/BillingAlerts/CardsExpiringSoon";
import PaymentAlerts from "pages/BillingAlerts/PaymentAlerts";
import CardTableCompare from "pages/BillingAlerts/CardTableCompare";
import TwilioNotifications from "pages/Admin/TwilioNotifications";
import FreeEstimatesAdmin from "pages/Admin/FreeEstimates";
import InsuranceContactsAdmin from "pages/Admin/InsuranceContacts";
import AgentPropertyLeads from "pages/Agent/PropertyLeads";
import MyPropertyLeads from "pages/Agent/MyPropertyLeads";
import PropertyCollections from "pages/Agent/PropertyCollections";
import HomeownerRecommendedProperties from "pages/Homeowner/RecommendedProperties";
import MechanicsLienIntakes from "pages/MechanicsLien";
import AccessDenied from "pages/AccessDenied";
import ServiceReviews from "pages/ServiceReviews";
import PartnerProfile from "pages/PartnerProfile";

const WalletPage = lazy(() => import("pages/Wallet"));

const WalletRouteFallback = () => (
  <div className="page-content tailwind-prefix">
    <div
      className="flex min-h-[420px] items-center justify-center"
      role="status"
      aria-label="Loading wallet"
    >
      <div className="h-9 w-9 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600" />
    </div>
  </div>
);

const authProtectedRoutes = [
  { path: "/service-reviews", component: <ServiceReviews /> },
  { path: "/people/:id", component: <PartnerProfile /> },
  { path: "/access-denied", name: "Access Denied", component: <AccessDenied /> },
  // Dashboard
  { path: "/dashboard", component: <RealEstate /> },
  {
    path: "/create-by-ai",
    name: "ListViewInvoice",
    component: <AIContractChatScreen />,
  },
  {
    path: "/property_insurance",
    name: "ListViewInvoice",
    component: <PropertyInsurance />,
  },
  {
    path: "/team_management",
    name: "ListViewInvoice",
    component: <TeamManagement />,
  },
  {
    path: "/project-details/:id",
    name: "ListViewInvoice",
    component: <LeadDetailsPage />,
  },
  {
    path: "/credit_card_precessing",
    name: "ListViewInvoice",
    component: <CreditCardProcessing />,
  },
  { path: "/merchant/onboarding", name: "Merchant Onboarding", component: <Navigate to="/merchant/business-info" replace /> },
  { path: "/merchant/business-info", name: "Merchant Business Info", component: <MerchantPage mode="business-info" /> },
  { path: "/merchant/owners", name: "Merchant Owners", component: <MerchantPage mode="owners" /> },
  { path: "/merchant/kyc", name: "Merchant KYC", component: <MerchantPage mode="kyc" /> },
  { path: "/merchant/status", name: "Merchant Status", component: <MerchantPage mode="status" /> },
  { path: "/merchant/payment-setup", name: "Merchant Payment Setup", component: <MerchantPage mode="payment-setup" /> },
  { path: "/merchant/payments", name: "Merchant Payments", component: <MerchantPage mode="payments" /> },
  { path: "/merchant/payouts", name: "Merchant Payouts", component: <MerchantPage mode="payouts" /> },
  { path: "/logan-ai-admin", name: "Logan AI Administration", component: <LoganAdmin /> },
  { path: "/logan-ai", name: "Logan AI", component: <LoganAI /> },
  { path: "/billing/cards-expiring-soon", name: "Cards Expiring Soon", component: <CardsExpiringSoon /> },
  { path: "/billing/payment-alerts", name: "Payment Alerts", component: <PaymentAlerts /> },
  { path: "/twilio-notifications", name: "Twilio Notifications", component: <TwilioNotifications /> },
  {
    path: "/wallet",
    name: "Wallet",
    component: (
      <Suspense fallback={<WalletRouteFallback />}>
        <WalletPage />
      </Suspense>
    ),
  },
  { path: "/free-estimates", name: "Free Estimates", component: <FreeEstimatesAdmin /> },
  { path: "/insurance-contacts", name: "Insurance Contacts", component: <InsuranceContactsAdmin /> },
  { path: "/mechanics-lien-intakes", name: "Mechanics Lien Intakes", component: <MechanicsLienIntakes /> },
  { path: "/agent-property-leads", name: "Available Property Leads", component: <AgentPropertyLeads /> },
  { path: "/agent-my-property-leads", name: "My Property Leads", component: <MyPropertyLeads /> },
  {
    path: "/life_health_insurance",
    name: "ListViewInvoice",
    component: <ComingSoon />,
  },
  {
    path: "/investments",
    name: "ListViewInvoice",
    component: <ComingSoon />,
  },
  {
    path: "/invoices-list",
    name: "ListViewInvoice",
    component: <ListViewInvoice />,
  },
  {
    path: "/apps-invoices-overview",
    name: "OverviewInvoice",
    component: <OverviewInvoice />,
  },
  {
    path: "/apps-invoices-create",
    name: "CreateInvoice",
    component: <CreateInvoice />,
  },

  {
    path: "/contracts-list",
    name: "ListViewContracts",
    component: <ListViewContracts />,
  },
  {
    path: "/property-manager",
    name: "addProperty",
    component: <AddPropertyManager />,
  },
  {
    path: "/apps-contracts-overview",
    name: "OverviewContracts",
    component: <OverviewContracts />,
  },
  { path: "/apps-tickets-overview", name : "TicketsOverview" ,component: <TicketsOverview/> },
  { path: "/apps-tickets-list", name : "ListViewTickets" ,component: <ListViewTickets /> },
  { path: "/apps-chat", name : "Chat" ,component: <Chat /> },

  {
    path: "/apps-contracts-create",
    name: "CreateContracts",
    component: <CreateContracts />,
  },

  {
    path: "/apps-tickets-overview",
    name: "TicketsOverview",
    component: <TicketsOverview />,
  },
  {
    path: "/apps-tickets-list",
    name: "TicketsOverview",
    component: <ListViewTickets />,
  },

  {
    path: "/apps-real-estate-grid",
    name: "ListingGrid",
    component: <ListingGrid />,
  },
  
  {
    path: "/live-contract-details",
    name: "ListingGrid",
    component: <LiveContractDetails />,
  },
  {
    path: "/apps-real-estate-agent-grid-view",
    name: "AgentGrid",
    component: <AgentGrid />,
  },
  {
    path: "/apps-real-estate-agent-homeowner",
    name: "AgentGrid",
    component: <InviteHomeOwners />,
  },
  {
    path: "/agent-property-recommendations",
    name: "Property Recommendations",
    component: <PropertyCollections />,
  },
  {
    path: "/contract-tutorial-and-plans",
    name: "Contract Tutorial",
    component: <ContractTutorial />,
  },
  {
    path: "/marketing",
    name: "Marketing",
    component: <MarketingComponent />,
  },
  {
    path: "/create-your-team",
    name: "SubcontractorsGrid",
    component: <SubcontractorsGrid />,
  },

  {
    path: "/apps-real-estate-property-overview",
    name: "PropertyOverview",
    component: <PropertyOverview />,
  },
  {
    path: "/apps-real-estate-explore-contractor",
    name: "PropertyOverview",
    component: <ContractExplorePage />,
  },
  {
    path: "/apps-real-estate-add-properties",
    name: "AddEarning",
    component: <AddEarning />,
  },
  {
    path: "/suggested-contractors",
    name: "SuggestedContractors",
    component: <SuggestedContractrDashboard />,
  },
  {
    path: "/recommended-properties",
    name: "Recommended Properties",
    component: <HomeownerRecommendedProperties />,
  },


  {
    path: "/",
    exact: true,
    name: "Navigate",
    component: <Navigate to="/dashboard" />,
  },

  // Pages
  // Starter

  // Terms & Condition

  // Terms & Condition
  {
    path: "/pages-term-conditions",
    name: "TermsContions",
    component: <TermsContions />,
  },

  // Timeline
  { path: "/pages-timeline", name: "TimeLine", component: <TimeLine /> },

  // FAQs
  { path: "/pages-faqs", name: "Faqs", component: <Faqs /> },

  // Contacts
  { path: "/pages-contacts", name: "Contacts", component: <Contacts /> },
  {
    path: "/pages-contractors",
    name: "Contractors",
    component: <Contractors />,
  },

  {
    path: "/pages-credentials",
    name: "Credentials",
    component: <Credentials />,
  },

  // Pricing
  { path: "/pages-pricing", name: "Pricing", component: <Pricing /> },

  // Profile
  { path: "/pages-profile", name: "Profile", component: <Profile /> },
  { path: "/profile", name: "My Profile", component: <ModernProfile /> },
  {
    path: "/pages-contracor-profile",
    name: "Contracotr Profile",
    component: <ContracotrProfile />,
  },

  //Projects
  { path: "/pages-projects", name: "Projects", component: <NewLeadsPage /> },
  {
    path: "/pages-user-overview",
    name: "Overview User",
    component: <OverviewUser />,
  },
  {
    path: "/recent-contractors",
    name: "Overview User",
    component: <RecentContractors />,
  },
  {
    path: "/recent-contractors/:id",
    name: "Contractor Profile",
    component: <RecentContractorProfile />,
  },
  {
    path: "/suggested-contractors",
    name: "Overview User",
    component: <SuggestedContractrDashboard />,
  },
  { path: "/get-contracts", name: "Projects", component: <GetProject /> },
  { path: "/view-sub-contracts", name: "Projects", component: <ViewSubcontracts /> },
  { path: "/live-contracts", name: "Projects", component: <LiveContracts /> },
  { path: "/messages", name: "Messages", component: <Messages /> },
  { path: "/leadHistory", name: "Projects", component: <LeadsHistory /> },
  {
    path: "/create-contract",
    name: "Create Contract",
    component: <CreateContract />,
  },

  {
    path: "/create-sworn-contracts",
    name: "Create Sworn Contracts",
    component: <CreateSwornContractor />,
  },
  {
    path: "/create-sworn-homeowner",
    name: "Create Sworn Homeowner",
    component: <CreateSwornHomeowner />,
  },
  {
    path: "/chat-room",
    name: "Chat",
    component: <Chatroom />,
  },
  {
    path: "/project-overview",
    name: "Project Overview",
    component: <ProjectOverview />,
  },
  {
    path: "/project-requested",
    name: "Requested Leads",
    component: <NewLeadsPage />,
  },

  {
    path: "/project-ongoing-leads",
    name: "Ongoing Leads",
    // component: <OngoingLeads />,
    component: <NewLeadsPage />,
  },

  //{ path: "/proposal-overview", name : "Proposal Overview" ,component: <ProposalOverview /> },

  //admin
  {
    path: "/pages-all-contractors",
    name: "All Contractors",
    component: <NewContractorDetails />,
  },
  {
    path: "/pages-all-homeowners",
    name: "All Homeowners",
    component: <HomeownerListAdmin />,
  },
  {
    path: "/escrow-requests",
    name: "All Homeowners",
    component: <EscrowRequest />,
  },
  {
    path: "/pages-all-leads",
    name: "All Leads",
    component: <AllLeads />,
  },
  {
    path: "/catogery-master",
    name: "Catogery Master",
    component: <CategoryMasterModern />,
  },
  {
    path: "/sub-catogery-master",
    name: "Sub Catogery Master",
    component: <SubCategoryMasterModern />,
  },
  {
    path: "/coupan-dashboard",
    name: "Coupan Dashboard",
    component: <CoupanDashboard />,
  },
  {
    path: "/version-controle",
    name: "Version Controle",
    component: <VersionControl />,
  },
  {
    path: "/push-notification",
    name: "Coupan Dashboard",
    component: <NotificationSender />,
  },
  {
    path: "/mls-cache-control",
    name: "MLS Cache Control",
    component: <MlsCacheControl />,
  },
  {
    path: "/property-leads",
    name: "Property Leads",
    component: <PropertyLeadsAdmin />,
  },
  {
    path: "/pages-single-homeowner",
    name: "Homeowner",
    component: <AdminHomeownerProfile />,
  },
  {
    path: "/pages-all-real-estate-agents",
    name: "All Real Estate Agents",
    component: <AdminRealEstateAgentsData />,
  },
  {
    path: "/pages-all-admins",
    name: "Platform Access",
    component: <Navigate to="/platform-access" replace />,
  },
  {
    path: "/platform-access",
    name: "Platform Access",
    component: <PlatformAccess />,
  },
  {
    path: "/pages-single-contractors",
    name: "Contractor",
    component: <AdminContractorProfile />,
  },
  {
    path: "/pages-all-forms",
    name: "Forms Data",
    component: <AdminFormsData />,
  },
  {
    path: "/pages-all-subscribers",
    name: "Subscribers Data",
    component: <AdminSubscribersData />,
  },

  // Profile Setting
  {
    path: "/pages-profile-settings",
    name: "ProfileSetting",
    component: <ProfileSetting />,
  },

  //Transcations
  {
    path: "/pages-all-transactions",
    name: "Transactions Data",
    component: <TransactionData />,
  },
  {
    path: "/kyc-status-page",
    name: "Kyc Status",
    component: <KYCPendingView />,
  },
  {
    path: "/kyc-form-page",
    name: "Kyc Form",
    component: <KYCForm />,
  },
  { path: "*", component: <Navigate to="/dashboard" replace /> },
];

const publicRoutes = [
  // Authentication
  { path: "/login", name: "Login", component: <LoginScreen2 /> },
  { path: "/logout", name: "Logout", component: <Logout /> },
  { path: "/guest/subcontract-sign", name: "Sign Subcontract", component: <GuestSubcontractSign /> },
  { path: "/guest/homeowner-contract-sign", name: "Sign Homeowner Contract", component: <GuestHomeownerContractSign /> },


  { path: "/auth-lockscreen", name: "LockScreen", component: <LockScreen /> },

 
];

export { authProtectedRoutes, publicRoutes };
